import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const ToastCleaner = () => {
  const location = useLocation();

  useEffect(() => {
    // Automatically dismiss all toasts on route change
    toast.dismiss();
  }, [location.pathname]);

  return null;
};

export default ToastCleaner;